<template>
    <div>
        
    <div class="p_title container bottomline mt30">
        <div class="titlebox mt20">
            <h5>{{mainmenuitem.title}}</h5>
            <p>{{mainmenuitem.description}}</p>
        </div>
        <ul class="titlemenu mt50">
            <li v-for="(menu,index) in childmenus" :key="index" :class="pid == menu.id ? 'active' : '' ">
                <a href="javascript:void(0)" @click="gotoinfo(menu)">{{menu.title}}</a>
            </li>
        </ul>
        <infomenu :menuarray="childmenus" @gotoinfo="gotoinfo" :pid="pid"></infomenu>
    </div>
    <div class="p_body container mt30">
        <ul class="p_body_list">
            <li v-for="(item) in tableData" :key="item.id" style="width: 100%;">
                <a href="javascript:void(0)" @click="gotodetail(item.id)">
                <img :src="imgbaseurl+item.headImgUrl" class="img1" :alt="item.title" />
                <div class="p_body_list_discribtion discribtion1">
                    <p class="newstitle">{{item.title}}</p>
                    <span>{{item.description}}</span>
                </div>
                <div class="p_body_list_date">
                    <p class="p_body_list_date_word">{{formatdata(item.createdTimeStr)}}</p>
                    <p><span class="icofont-rounded-right"></span></p>
                </div>
                </a>
            </li>
        </ul>
        <Pager
        v-if="!dataChanged" 
        ref="pager"
        :pageSize="pageSize" 
        :curPage="curPage" 
        :total="total"  
        @setPage="gotoPage"
        @setRowNum="changeRowNum" />
    </div>
  
    </div>
</template>

<script>

import util from '../tools/js/util';
import Pager from '@/components/Pager'
import configration from '../tools/js/enumconfig'
// import configration from '../tools/js/enumconfig'
import infomenu from '../components/infomenu'

export default {
    data(){
        return {
            totleCount:0,
            itemData:{},
            tableData:[],
            parameters:{
                CurrentPage:1,
                PageSize:10,
                filter:{
                    parentId:'',
                    Type:0
                }
            },
            id:'',
            showtitle:'信息公开',
            imgbaseurl : this.$baseURL.fileurl,
            pidpublicguide:configration.config.enum.pidpublicguide,
            pidpublicstipulate:configration.config.enum.pidpublicstipulate,
            pidpubliccatalog:configration.config.enum.pidpubliccatalog,

            //分页
            curPage:1,//当前页
            total:0,//总共页数
            pageSize:20,//每页记录数 
            dataChanged:false,

            outsidelink:configration.config.enum.news_outside_link,
            mainmenuitem:{},            //主显示分类
            childmenutree:[],   //  treemenu
            childmenus:[],
            fid:'',
            pid:''
        }
    },
     components:{
       "Pager":Pager,
       infomenu
    },
     methods:{
         initmenu(){
            let vm = this;

            if(vm.childmenutree == undefined || vm.childmenutree.length == 0) 
            { 
                vm.childmenutree = JSON.parse(localStorage.getItem(configration.config.enum.cache_menu))
            }

            vm.childmenus = [];
            if(vm.fid.length>0){
                //获取子菜单
                for(let i=0;i< vm.childmenutree.length;i++ ){
                    if(vm.childmenutree[i].id == vm.fid)
                    {
                        vm.mainmenuitem = vm.childmenutree[i];
                        vm.childmenus = vm.childmenutree[i].childs;
                        break;
                    }
                }
            }
        },
        refresh(){//用于刷新组件，需手动调用
            this.dataChanged = true
            this.$nextTick(() => {
                this.getList();
                this.dataChanged = false
            })
        },
        refresh2(){//用于刷新组件，需手动调用
            this.dataChanged = true
            this.$nextTick(() => {
                this.dataChanged = false
            })
        },
        gotoPage(page){
            this.curPage = page;
             this.parameters.CurrentPage = page;
            this.refresh();
        },
        changeRowNum(pageSize){
            this.pageSize = pageSize;
            this.refresh();
        },
        formatdata:function(e){
            //return util.formatDate.format(e,'yyyy-MM')
            return e.substr(0,7);
        },
        getData:function(id){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getitem?id='+id)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemData = response.data.data;
                    vm.showtitle = vm.itemData.title;
                }
            });
        },

        getList:function(){
            let vm = this;
            vm.parameters.PageSize = vm.pageSize;
            vm.parameters.CurrentPage = vm.curPage;
            vm.$httpi.post('/api/v1/articles/doc/GetList', vm.parameters)
            .then(function (response) {
                if(response.data.success){
                    vm.tableData = response.data.data.list;
                    vm.total = Math.ceil(response.data.data.total/vm.parameters.PageSize);
                    vm.refresh2();
                    //vm.curPage = response.data.data.total;
                    vm.tableData.forEach(el=>{
                        el.createdTime = util.formatDate.format(el.createdTime,'yyyy-MM-dd')
                    });

                }
            });
            
        },
        gotodetail(id){
            const vm = this;
            vm.$router.push({path:'/pub/detail',query:{id:id,pid:vm.parameters.filter.parentId,fid:vm.fid}});
        },

        gotoinfo(item){
            const vm = this;
            let url = '/info';
            if(item.id == configration.config.enum.pidhonor)
            {
                url = '/pub/list';
            }
            vm.$router.push({path:url,query:{pid:item.id,fid:item.parentId}});
            //vm.initpage();
        },
        initpage(){
            let vm = this;
            //绑定
            if(vm.$route.query.fid!=undefined && vm.$route.query.fid.length>0)
            {
                vm.fid = vm.$route.query.fid;
            }
            if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
            {
                vm.parameters.filter.parentId = vm.$route.query.pid;
                vm.pid = vm.$route.query.pid;
                vm.getList();
            }
            vm.initmenu();
        }
     },
     mounted() {
        let vm = this;
        //绑定
        vm.initpage();
    },
    watch: {
        '$route' (to, from) { //监听路由是否变化
            if(to.query.pid != from.query.pid){
                this.parameters.filter.parentId = to.query.pid;
                this.getList();//重新加载数据
            }
        }
    }
}
</script>
